import {Component, Input} from '@angular/core';
import {FormControl, FormGroupDirective, ReactiveFormsModule} from "@angular/forms";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-filter-input',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgIf
  ],
  templateUrl: './filter-input.component.html',
  styleUrl: './filter-input.component.scss'
})
export class FilterInputComponent {

  @Input() required: boolean = false;
  @Input() placeholder: string = '';
  @Input() type: string = 'text';
  @Input() maxlength: number = 255;
  @Input() showlabel: boolean = true;
  @Input() control!: FormControl;

}
